import { ProfileRowDataContainer } from 'app/components/profile/ProfileStyles';
import React from 'react';
import { Container, ImageContainer } from 'app/components/match/bestPlayer/VotingLeaderStyles';
import { Typography } from '@fupa/fupa-uikit';
import { Skeleton } from '@mui/material';
const LoadingSkeleton = () => {
  return /*#__PURE__*/React.createElement(Container, {
    "data-sentry-element": "Container",
    "data-sentry-component": "LoadingSkeleton",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(ImageContainer, {
    "data-sentry-element": "ImageContainer",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "circular",
    width: "100%",
    height: "100%",
    "data-sentry-element": "Skeleton",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  })), /*#__PURE__*/React.createElement(ProfileRowDataContainer, {
    "data-sentry-element": "ProfileRowDataContainer",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subheading",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    width: 150,
    "data-sentry-element": "Skeleton",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    width: 150,
    "data-sentry-element": "Skeleton",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  }))));
};
export default LoadingSkeleton;